import SearchResult from "./SearchResult";
export default SearchResult;
